// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-429e2330] .w-date-fixed {\r\n  width: 170px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
